export async function menuCompletionSource(context) {
  const match = context.matchBefore(/\[#menu\s+[\w-]*/)
  if (!match) return null
  if (match.from === match.to && !context.explicit) return null

  const prefix = "[#menu "
  // match.text contains the full matched string
  const query = match.text.slice(prefix.length)

  try {
    const res = await fetch(`/api/v1/autocomplete/menus.json?query=${encodeURIComponent(query)}`, {
      headers: {
        "content-type": "application/json"
      }
    })
    const json = await res.json()

    return {
      from: match.from + prefix.length,
      options: json["menus"].map(img => ({
        label: img.alias,
        type: "menu"
      }))
    }
  } catch(err) {
    if (err.name !== "AbortError") throw err
  }
}
